import React from 'react'
import { t } from '../../components/i18n/i18n'
import BibleViewer from '../../components/bible/BibleViewer'
import back from '../../assets/images/elements/holyBible.jpeg'

export const Bible = () => (
  <>
    <style>{`
      @media (max-width: 767px) {
        .bible-page {
          max-width: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
          border-radius: 0 !important;
          border-left: none !important;
          border-right: none !important;
          box-shadow: none !important;
        }
      }
    `}</style>

    <div style={s.hero}>
      <img src={back} alt='' style={s.heroImg} />
      <div style={s.heroOverlay} />
      <h1 style={s.heroTitle}>{t('bibleOnline')}</h1>
    </div>

    <div style={s.page} className='bible-page'>
      <BibleViewer />
    </div>
  </>
)

const s = {
  hero: {
    position: 'relative',
    width: '100%',
    height: '15vh',
    overflow: 'hidden',
  },
  heroImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  heroOverlay: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(to bottom, rgba(18,8,3,0.45) 0%, rgba(45,31,20,0.7) 100%)',
  },
  heroTitle: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    fontSize: '36px',
    fontWeight: '800',
    color: '#fff',
    textShadow: '0 2px 16px rgba(0,0,0,0.6)',
    letterSpacing: '0.5px',
    fontFamily: '"Segoe UI", system-ui, sans-serif',
    textAlign: 'center',
    padding: '0 24px',
  },
  page: {
    maxWidth: '95%',
    margin: '28px auto 50px',
    background: '#fff',
    borderRadius: '16px',
    padding: '28px',
    boxShadow: '0 2px 16px rgba(92,61,46,0.08)',
    border: '1px solid #f0e4d4',
  },
}
